import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  Suspense,
  lazy,
} from "react";
import {
  deleteItem,
  deleteMultipleItem,
  fetchData,
  toggleStatus,
} from "../../../utils/apiUtils";
import { DeleteButton, PlusButton } from "../../../helper/ImageFormat";
import DeleteModel, { confirmBulkDelete } from "../../../Components/DeleteModel";
import Breadcrumb from "../../../helper/Breadcrumb";
import BrandTable from "./BrandTable";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
const BrandModel = lazy(() =>
  import("../../../Model/Model").then((mod) => ({ default: mod.BrandModel }))
);

const Brand = () => {
  const [loading, setLoading] = useState(true);
  const [brands, setBrands] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [search, setSearch] = useState("");
  const [deleteItemId, setDeleteItemId] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [updatedata, setupdatedata] = useState(null);
  const [selected, setSelected] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const totalPages = useMemo(
    () => Math.ceil(totalCount / perPage),
    [totalCount, perPage]
  );

  const handleEditClick = (data) => {
    setEditingId(data.id);
    const { createdAt, id, updatedAt,  ...otherData } = data;
    setupdatedata(otherData);
    setModalOpen(true);
  };

  const fetchBrands = useCallback(
    async (page = 1, searchQuery = "") => {
      setLoading(true);
      await fetchData(
        "brand-pagination",
        { perPage, pageNo: page, search: searchQuery },
        setBrands,
        setTotalCount,
        setCurrentPage,
        setLoading
      );
    },
    [perPage]
  );


  useEffect(() => {
    const delay = search ? 500 : 0;

    const handler = setTimeout(() => {
      fetchBrands(currentPage, search);
    }, delay);

    return () => clearTimeout(handler);
  }, [search, perPage]);






  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };
  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("brand", deleteItemId?.id, fetchBrands,[deleteItemId?.image]);
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const handleStatusToggle = async (brand) => {
    const data = await toggleStatus(
      "brand-status",
      brand?.id,
      fetchBrands
    );
    if (Object.keys(data).length > 0) {
      setBrands((prevbrands) =>
        prevbrands.map((curr) =>
          curr.id === brand.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchBrands(page);
    }
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setEditingId(false);
    setupdatedata({});
  };

  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Brands", path: "/brands" },
  ];



  const handlebulkDelete = async () => {
    await confirmBulkDelete({
      itemType: "Brands",
      selectedIds: selected,
      deleteApiCall: (ids) => deleteMultipleItem("brand-bulk-delete", ids),
      refreshCallback: fetchBrands,
    });

  };

  return (
    <>
      <div className="content-wrapper">
        <div
          className="page-header mt-5"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h3 className="custom-page-title">Brands</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div
          className="d-flex justify-content-between mb-2"
          style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
        >
         <PerPageSelect value={perPage} onChange={setPerPage}/>

          <div style={{ display: "flex", gap: "20px" }}>
           <TableSearch value={search} onChange={setSearch} />

            <PlusButton handleAdd={toggleModal} module={"brands"} />
            {selected && selected?.length > 0 && (
              <DeleteButton handleAdd={handlebulkDelete} name={"selected currency"} module={"brands"} />
            )}
          </div>
        </div>

        <BrandTable
          loading={loading}
          brands={brands}
          currentPage={currentPage}
          perPage={perPage}
          totalPages={totalPages}
          totalCount={totalCount}
          handlePageClick={handlePageClick}
          handleEditClick={handleEditClick}
          handleDelete={handleDelete}
          handleStatusToggle={handleStatusToggle}
          selected={selected}
          setSelected={setSelected}
        />
      </div>




      <Suspense fallback={<div>Loading...</div>}>
        {modalOpen && (
          <BrandModel
            modalOpen={modalOpen}
            toggleModal={toggleModal}
            editingId={editingId}
            setEditingId={setEditingId}
            setupdatedata={setupdatedata}
            updatedata={updatedata}
            fetchCurrencies={fetchBrands}
          />
        )}
      </Suspense>

      <Suspense fallback={<div>Loading...</div>}>
        <DeleteModel
          deleteModalOpen={deleteModalOpen}
          setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
          onConfirm={confirmDelete}
          itemName="Brand"
          isDeleting={isDeleting}
        />
      </Suspense>
    </>
  );
};

export default Brand;
